import { AppContext } from "App";
import { useContext } from "react";
import { formatCountry } from "utils/string";

const ForecastProductView = ({ product }) => {
  const { user } = useContext(AppContext);

  return (
    <div>
      <div className="min-w-[300px]">
        {product.countryCodeOfOrigin !== "CN" && (
          <div>{formatCountry(product.countryCodeOfOrigin, true, true)}</div>
        )}
        <div>
          <b>{product.number}</b>

          {product.version && (
            <span className="pl-2 opacity-70">(v{product.version})</span>
          )}

          {user?.email === "charles@waboba.com" && (
            <span className="opacity-50 pl-2">
              W#{product.id},OD#{product.odooId || "??"}
            </span>
          )}
        </div>
      </div>

      <div className="text-xs opacity-70">
        {product.name}
        {product.itemsPerSet ? ` (${product.itemsPerSet}/ctn)` : ""}
      </div>
    </div>
  );
};

export default ForecastProductView;
